import {
    CALENDAR_COLOR_CONTRAST,
    CALENDAR_EVENT_PROJECT,
    CALENDAR_NO_USER_ICON,
    CalendarViewType,
    // CalendarWeekView
} from "../const";
import {EventType} from "../../../gd/const/event";

export const CalendarDefaultSettings = {

    eventTypes:     [
        EventType.COMPANY_HOLIDAY,
        EventType.PROJECT_DEADLINE,
        EventType.PROJECT_MILESTONE,
        EventType.PROJECT_EVENT,
        EventType.PERSONAL_PAID_VACATION,
        EventType.PERSONAL_SICK_LEAVE,
        EventType.TASK_DEADLINE,
        EventType.MEETING
    ],

    // Display settings
    highlightPastDue            : true,
    showCalendar                : true,
    showWeekNumber              : false,
    showOnlyWorkdays            : false,

    // weekView                    : CalendarWeekView.FULL_WEEK,

    displayMode                 : CalendarViewType.MONTH,
    filters                     : {},
    eventsIcon                  : true,

    eventsShowProject           : false, // CALENDAR_EVENT_PROJECT.PROJECT,
    eventsShowTags              : false,

    //Event color
    colorCompanyEvents          : CALENDAR_COLOR_CONTRAST,
    colorProjectEventsFieldId   : 'isAccomplished',
    colorPersonalEvents         : CALENDAR_COLOR_CONTRAST,
    colorMeetings               : CALENDAR_COLOR_CONTRAST,
    colorTasksFieldId           : 'statusId',

    eventsUserIcon              : false,

}
